var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-remainder-table',{ref:"dialog",attrs:{"title":_vm.title,"companyID":_vm.companyID,"tableConfig":_vm.config}})}
var staticRenderFns = []

export { render, staticRenderFns }